'use client';
import { motion } from 'motion/react';
import {
  Ship,
  Zap,
  Droplets,
  Train,
  Building2,
  Radio,
  Factory,
  Cpu,
} from 'lucide-react';

const sectors = [
  { name: 'Maritime & Ports', icon: Ship },
  { name: 'Energy', icon: Zap },
  { name: 'Water', icon: Droplets },
  { name: 'Transport', icon: Train },
  { name: 'Government', icon: Building2 },
  { name: 'Telecoms', icon: Radio },
  { name: 'Manufacturing', icon: Factory },
  { name: 'Industrial', icon: Cpu },
];

export function TrustBar() {
  return (
    <section className="relative border-y border-border/50 bg-secondary/30 py-12">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="font-heading text-xs font-semibold uppercase tracking-wide-caps text-muted-foreground">
            Designed for UK Critical National Infrastructure sectors
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-8 flex flex-wrap items-center justify-center gap-x-8 gap-y-6 sm:gap-x-12"
        >
          {sectors.map((sector, index) => {
            const Icon = sector.icon;
            return (
              <motion.div
                key={sector.name}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.1 * index }}
                className="group flex items-center gap-2.5 text-muted-foreground/70 transition-colors hover:text-muted-foreground"
              >
                <div className="flex h-9 w-9 items-center justify-center rounded-lg border border-border/50 bg-card/50 transition-all duration-300 group-hover:border-accent/30 group-hover:bg-accent/5">
                  <Icon className="h-4 w-4" strokeWidth={1.5} />
                </div>
                <span className="hidden font-heading text-sm font-medium sm:inline">
                  {sector.name}
                </span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
